import { Button, Card, Checkbox, Col, Input, Drawer, message, Modal, Popconfirm, Row, Select, Spin, Table, Tabs, Tag, Grid, Timeline } from "antd";
import { DeleteOutlined, EditOutlined, EyeOutlined, FilePdfOutlined, PlusOutlined, SendOutlined, RocketOutlined, CarOutlined, NodeIndexOutlined, ClockCircleOutlined } from "@ant-design/icons";
import { useEffect, useMemo, useState } from "react";
// import { FaPlane, FaTruck, FaShip } from "react-icons/fa";
// import {
//     FaPlaneDeparture,
//     FaTruckMoving,
//     FaShip
// } from "react-icons/fa6";
import InputBarang from "./inputData";
import { API } from "../../../setup/setupAxios";
import { STATUS_MAP_BARANG, STATUS_MAP_UANG_IN, STATUS_MAP_UANG_OUT, STATUS_OPTION_BARANG, STATUS_OPTION_UANG_IN, STATUS_OPTION_UANG_OUT } from "../../../utils/dataUpdateStatus";
import PDFModal from "../../../components/models/pdf/PDFModal";
import ResiPDF from "./pdfResi";
import { pdf } from "@react-pdf/renderer";
import { PROSES_ORDER_BARANG, PROSES_ORDER_UANG_IN, PROSES_ORDER_UANG_OUT, statusConfigBarang, statusConfigUangIn, statusConfigUangOut } from "../../../utils/dataTracking";
import moment from "moment";
import { Plane, Ship, Truck } from "lucide-react";

const { Option } = Select;

const { TabPane } = Tabs;

const { useBreakpoint } = Grid;

const TableResult = ({ setLoadingSpin }) => {
    const screens = useBreakpoint();
    const isMobile = !screens.md;
    const [data, setData] = useState([]);
    const [pdfOpen, setPdfOpen] = useState(false);
    const [trackingOpen, setTrackingOpen] = useState(false);
    const [trackingData, setTrackingData] = useState([]);
    const [trackingLoading, setTrackingLoading] = useState(false);
    const [trackingRecord, setTrackingRecord] = useState(null);
    const addHoursToLocalTime = (hoursToAdd) => {
        const originalDate = new Date();
        originalDate.setHours(originalDate.getHours() + hoursToAdd);
        return originalDate.toISOString();
    };
    const result = addHoursToLocalTime(7)
    const [selectedRowKeys, setSelectedRowKeys] = useState([]);
    const [selectedRows, setSelectedRows] = useState([]);
    const [searchResi, setSearchResi] = useState("");
    const [currentPage, setCurrentPage] = useState(1);
    const [pageSize, setPageSize] = useState(5);
    const [showModal, setShowModal] = useState(false)
    const [editData, setEditData] = useState(null);
    const [viewMode, setViewMode] = useState(false);
    const [loading, setLoading] = useState(false);
    const [statusModalOpen, setStatusModalOpen] = useState(false);
    const [selectedRecord, setSelectedRecord] = useState(null);
    const [selectedStatus, setSelectedStatus] = useState(null);
    const [statusLoading, setStatusLoading] = useState(false);
    const selectedKodePengiriman = selectedRecord?.[0]?.kodePengiriman;
    const STATUS_MAP = 
        selectedKodePengiriman === "01" ?
        STATUS_MAP_BARANG :
        selectedKodePengiriman === "02" ?
        STATUS_MAP_UANG_OUT :
        selectedKodePengiriman === "03" ?
        STATUS_MAP_UANG_IN : null;
    
    console.log(selectedRecord)
    const STATUS_OPTION = 
        selectedKodePengiriman === "01" ?
        STATUS_OPTION_BARANG :
        selectedKodePengiriman === "02" ?
        STATUS_OPTION_UANG_OUT :
        selectedKodePengiriman === "03" ?
        STATUS_OPTION_UANG_IN : null;

    const handleAdd = () => {
        setEditData(null);
        setViewMode(false);
        setShowModal(true);
    };
    const handleEdit = (record) => {
        setEditData(record);
        setViewMode(false);
        setShowModal(true);
    };
    const handleView = (record) => {
        setEditData(record);
        setViewMode(true);
        setShowModal(true);
    };
    const handleCloseModal = () => {
        setViewMode(false);
        setEditData(null);
        setShowModal(false);
    };
    const openPDF = (record) => {
        setSelectedRecord(record);
        setPdfOpen(true);
    };
    // const handleClickStatus = (record) => {
    //     setSelectedRecord(record);
    //     setSelectedStatus(record.status);
    //     setStatusModalOpen(true);
    // };
    const fetchTracking = async (record) => {
        try {
            setTrackingLoading(true);
            setTrackingOpen(true);
            setTrackingRecord(record);
            const res = await API(
                `/api/tracking/${record.noResi}?kodePengiriman=${record.kodePengiriman}`
            );
            const prosesOrder =
                record.kodePengiriman === "01"
                    ? PROSES_ORDER_BARANG
                    : record.kodePengiriman === "02"
                    ? PROSES_ORDER_UANG_OUT
                    : PROSES_ORDER_UANG_IN;
            const sorted = [...res.data.data].sort(
                (a, b) =>
                    (prosesOrder[a.kodeProses] || 0) -
                    (prosesOrder[b.kodeProses] || 0)
            );
            setTrackingData(sorted);
        } catch (err) {
            console.error(err);
            message.error("Gagal mengambil tracking");
        } finally {
            setTrackingLoading(false);
        }
    };
    const handleClickStatus = (record) => {
        let targetRows = selectedRows.length ? selectedRows : [record];
        const uniqueStatuses = [...new Set(targetRows.map(r => r.status))];

        if (uniqueStatuses.length > 1) {
            message.warning("Semua baris yang dipilih harus memiliki status yang sama");
            return;
        }

        setSelectedRecord(targetRows);
        setSelectedStatus(uniqueStatuses[0]);
        setStatusModalOpen(true);
    };

    const fetchData = async () => {
        setLoading(true)
        try {
          const response = await API("/api/barang");
          setData(response.data.data);
          return response.data.data
        } catch (error) {
          console.error('Error fetching data', error);
        } finally {
            setLoading(false);
        }
    };
    // const handleSendWA = async (record) => {
    //     try {
    //         const blob = await pdf(<ResiPDF record={record} />).toBlob()
    //         const fileUrl = URL.createObjectURL(blob)
    //         await API.put(`/api/barang/${record.noResi}/file`, {
    //             fileUrl: fileUrl
    //         })
    //         // await API.put(`/api/barang/${record.noResi}/file`, {
    //         // fileUrl: formData
    //         // })

    //         message.success("WhatsApp sent successfully")

    //     } catch (err) {
    //         console.error(err)
    //         message.error("Failed send WhatsApp")
    //     }
    // }
    // const handleSendWA = async (record) => {

    //     setLoadingSpin(true)

    //     try {

    //         const blob = await pdf(<ResiPDF record={record} />).toBlob()

    //         const formData = new FormData()
    //         formData.append("file", blob, `${record.noResi}.pdf`)
    //         formData.append("phone", record.noTeleponPengirim)

    //         await API.put(
    //             `/api/barang/${record.noResi}/file`,
    //             formData
    //         )

    //         message.success("WhatsApp sent successfully")

    //     } catch (err) {

    //         console.error(err)
    //         message.error("Failed send WhatsApp")

    //     } finally {

    //         setLoadingSpin(false)

    //     }
    // }
    const handleSearchResi = async (value) => {
        if (!value) {
            fetchData();
            return;
        }
        try {
            setLoading(true);
            const res = await API(`/api/filter-barang?q=${value}`);
            const result = Array.isArray(res.data.data) ? res.data.data : [res.data.data];
            setData(result);
            setCurrentPage(1);
        } catch (err) {
            message.error("No Resi tidak ditemukan");
            console.error(err);
        } finally {
            setLoading(false);
        }
    };

    // console.log(data)
    const AllShipmentData = useMemo(() => {
        const start = (currentPage - 1) * pageSize;
        if(data) {
            return data.slice(start, start + pageSize);
        } else if (!data) {
            return null
        }
    }, [data, currentPage, pageSize]);

    const activeData = data?.filter((val) => val?.status !== "Delivered")

    const ActiveShipmentData = useMemo(() => {
        const start = (currentPage - 1) * pageSize;
        if(activeData) {
            return activeData?.slice(start, start + pageSize);
        } else if (!activeData) {
            return null
        }
    }, [activeData, currentPage, pageSize]);
    const handleDelete = async (record) => {
        try {
            await API.delete(`/api/barang/${record}`);
            await fetchData();
            message.success("Data berhasil dihapus");
        } catch (error) {
            console.error("Gagal menghapus:", error);
            message.error("Gagal menghapus data");
        }
    }
    useEffect(() => {
        fetchData()
    }, [])
    useEffect(() => {
        if (!searchResi) fetchData();
    }, [searchResi]);

    const columns = [
    {
        title: "Shipment",
        key: "shipment",
        render: (_, record) => {
            const checked = selectedRowKeys.includes(record.noResi);
        return(
        <Card
            bordered={false}
            style={{
            borderRadius: 16,
            marginBottom: 12,
            boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
            background: "#fff"
            }}
            bodyStyle={{
            padding: 20
            }}
        >
            {/* HEADER */}
            <div
                style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    marginBottom: 18
                }}
            >
                <div
                    style={{
                    display: "flex",
                    alignItems: "center",
                    gap: 12
                    }}
                >
                    <Checkbox
                        checked={checked}
                        onChange={(e) => {
                        const isChecked = e.target.checked;

                        if (isChecked) {
                            setSelectedRowKeys([
                            ...selectedRowKeys,
                            record.noResi
                            ]);

                            setSelectedRows([
                            ...selectedRows,
                            record
                            ]);
                        } else {
                            setSelectedRowKeys(
                            selectedRowKeys.filter(
                                (key) => key !== record.noResi
                            )
                            );

                            setSelectedRows(
                            selectedRows.filter(
                                (row) => row.id !== record.noResi
                            )
                            );
                        }
                        }}
                    />
                    <div>
                    <div
                        style={{
                        fontSize: 12,
                        color: "#999"
                        }}
                    >
                        Ref ID
                    </div>

                    <div
                        style={{
                        fontWeight: 700,
                        fontSize: 18
                        }}
                    >
                        {record.noResi}
                    </div>
                    </div>
                </div>

                <Button
                    type="text"
                    onClick={() => handleClickStatus(record)}
                    style={{
                    background: "#fa8c16",
                    color: "#fff",
                    borderRadius: 20,
                    border: "none",
                    fontWeight: 600
                    }}
                >
                    {record.status}
                </Button>
            </div>

            {/* CONTENT */}
            <div
            style={{
                display: "grid",
                gridTemplateColumns: isMobile
                    ? "1fr"
                    : "repeat(5, 1fr)",
                gap: 16
            }}
            >
                
            {/* <div>
                <div className="label-card">Origin</div>
                <div className="value-card">{record.alamatPengirim}</div>
            </div> */}

            <div>
                <div className="label-card">Mode Of Shipment</div>
                <div className="value-card" style={{
                    display: "flex",
                    marginTop: 30,
                    alignItems: "center",
                    justifyContent: isMobile
                        ? "flex-start"
                        : "center",
                }}>
                {(record.modaTransportasi === "plane" || record.ModaTransportasi === "plane") && (
                    <Plane
                        size={42}
                        strokeWidth={1.8}
                        color="#1677ff"
                    />
                )}
                {(record.modaTransportasi === "truck" || record.ModaTransportasi === "truck") && (
                    <Truck
                        size={42}
                        strokeWidth={1.8}
                        color="#52c41a"
                    />
                )}
                {(record.modaTransportasi === "boat" || record.ModaTransportasi === "boat") && (
                    <Ship
                        size={42}
                        strokeWidth={1.8}
                        color="#722ed1"
                    />
                )}
                </div>
            </div>

            <div>
                <div className="label-card">Origin</div>
                <div className="value-card">{record.alamatPengirim || "JAKARTA"}</div>
            </div>

            <div>
                <div className="label-card">Booked</div>
                <div className="value-card">{moment(record.createdAt).format("DD MMMM YYYY")}</div>
            </div>

            <div>
                <div className="label-card">Pick-Up</div>
                <div className="value-card">{record.namaPengirim}</div>
            </div>

            {/* <div>
                <div className="label-card">Jenis Pengiriman</div>
                <div className="value-card">
                {record.kodePengiriman === "01"
                    ? "Barang"
                    : record.kodePengiriman === "02"
                    ? "Uang ke Luar Negeri"
                    : "Uang ke Indonesia"}
                </div>
            </div> */}

            {/* <div>
                <div className="label-card">Nama Pengirim</div>
                <div className="value-card">{record.namaPengirim}</div>
            </div> */}

            <div>
                <div className="label-card">Container Type</div>
                <div className="value-card">{record.namaBarang}</div>
            </div>

            <div>
                {/* <div className="label-card">Pick-Up</div>
                <div className="value-card">{record.namaPengirim}</div> */}
            </div>

            <div>
                <div className="label-card">Destination</div>
                <div className="value-card">{record.alamatPenerima}</div>
            </div>

            <div>
                <div className="label-card">ETA</div>
                <div className="value-card">{"-"}</div>
            </div>

            <div>
                <div className="label-card">Delivery</div>
                <div className="value-card">{record.namaPenerima}</div>
            </div>

            {/* <div>
                <div className="label-card">Jumlah</div>
                <div className="value-card">{record.jumlahBarang}</div>
            </div> */}

            <div>
                <div className="label-card">Delivery Type</div>
                <div className="value-card">
                {record.kodePengiriman === "01"
                    ? "Barang"
                    : record.kodePengiriman === "02"
                    ? "Uang ke Luar Negeri"
                    : "Uang ke Indonesia"}
                </div>
            </div>

            {/* <div>
                <div className="label-card">Total Ongkir</div>
                <div className="value-card">
                {record.currency} {record.totalOngkir}
                </div>
            </div> */}
            </div>

            {/* ACTION */}
            <div
                style={{
                    display: "flex",
                    justifyContent: isMobile
                        ? "flex-start"
                        : "flex-end",
                    flexWrap: "wrap",
                    marginTop: 20,
                    gap: 10
                }}
            >
            <Button
                type="primary"
                shape="circle"
                icon={<EditOutlined />}
                onClick={() => handleEdit(record)}
                title="Edit Data"
            />

            <Button
                shape="circle"
                icon={<EyeOutlined />}
                onClick={() => handleView(record)}
                title="Lihat Detail"
            />

            <Popconfirm
                placement="topRight"
                title="Hapus Data Pengiriman"
                description={`Apakah Anda yakin ingin menghapus data dengan resi ${record.noResi}?`}
                onConfirm={() => handleDelete(record.noResi)}
                okText="Ya, Hapus"
                cancelText="Batal"
            >
                <Button
                    danger
                    shape="circle"
                    icon={<DeleteOutlined />}
                    title="Hapus Data"
                />
            </Popconfirm>

            <Button
                shape="circle"
                style={{
                    background: "#eb2f96",
                    borderColor: "#eb2f96",
                    color: "#fff"
                }}
                icon={<FilePdfOutlined />}
                onClick={() => openPDF(record)}
                title="Cetak PDF Resi"
            />
            <Button
                shape="circle"
                type="primary"
                style={{
                    background: "#722ed1",
                    borderColor: "#722ed1"
                }}
                icon={<NodeIndexOutlined />}
                onClick={() => fetchTracking(record)}
                title="Tracking Pengiriman"
            />
            </div>
        </Card>
        )
        }
    }
    ];
    return(
        <>
        <div 
            style={{
                padding: isMobile ? 12 : 32,
                minHeight: "100vh",
                background:
                    "linear-gradient(180deg, #f4f7fb 0%, #eef2f7 100%)"
            }}
        >
            <Row gutter={[16, 16]}>
                <Col xs={24} md={6}>
                    <Button 
                        type="primary" 
                        style={{
                            marginBottom: 20,
                            width: window.innerWidth < 768 ? "100%" : "auto"
                        }} 
                        onClick={handleAdd}><PlusOutlined /> Tambah Data Pengiriman</Button>
                </Col>
                <Col xs={24} md={12} />
                <Col xs={24} md={6}>
                    <Input.Search
                        placeholder="Cari No Resi"
                        allowClear
                        value={searchResi}
                        onChange={(e) => setSearchResi(e.target.value)}
                        onSearch={handleSearchResi}
                        style={{
                            width: "100%",
                            marginBottom: 16
                        }}
                        enterButton="Cari"
                    />
                </Col>
            </Row>
            <div
                style={{
                    padding: window.innerWidth < 768 ? 16 : 24,
                    background: "#f5f5f5",
                    borderRadius: 20
                }}
            >
                {/* HEADER */}
                <div
                    style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        flexWrap: "wrap",
                        gap: 12,
                        marginBottom: 20
                    }}
                >
                <div>
                    <h2
                        style={{
                            margin: 0,
                            fontWeight: 700,
                            fontSize: window.innerWidth < 768 ? 20 : 28
                        }}
                    >
                    Freights
                    </h2>

                    <div style={{ color: "#888" }}>
                        {data.length} Shipments
                    </div>
                </div>
                </div>
                <Row gutter={[16, 16]} style={{ marginBottom: 24 }}>
                <Col xs={24} md={8}>
                    <Card
                        bordered={false}
                        style={{
                            borderRadius: 28,
                            marginBottom: 20,
                            border: "1px solid #f0f0f0",
                            boxShadow:
                                "0 10px 30px rgba(0,0,0,0.05)",
                            overflow: "hidden",
                            transition: "0.3s"
                        }}
                    >
                        <div style={{ color: "#888" }}>
                            Total Shipments
                        </div>

                        <div
                            style={{
                                fontSize: 32,
                                fontWeight: 700
                            }}
                        >
                            {data.length}
                        </div>
                    </Card>
                </Col>

                <Col xs={24} md={8}>
                    <Card
                        bordered={false}
                        style={{
                            borderRadius: 24,
                            boxShadow: "0 8px 24px rgba(0,0,0,0.06)"
                        }}
                    >
                        <div style={{ color: "#888" }}>
                            Active
                        </div>

                        <div
                            style={{
                                fontSize: 32,
                                fontWeight: 700,
                                color: "#1677ff"
                            }}
                        >
                            {activeData.length}
                        </div>
                    </Card>
                </Col>

                <Col xs={24} md={8}>
                    <Card
                        bordered={false}
                        style={{
                            borderRadius: 24,
                            boxShadow: "0 8px 24px rgba(0,0,0,0.06)"
                        }}
                    >
                        <div style={{ color: "#888" }}>
                            Delivered
                        </div>

                        <div
                            style={{
                                fontSize: 32,
                                fontWeight: 700,
                                color: "#52c41a"
                            }}
                        >
                            {
                                data.filter(
                                    (x) => x.status === "Delivered"
                                ).length
                            }
                        </div>
                    </Card>
                </Col>
            </Row>

                {/* TABS */}
                <Tabs defaultActiveKey="1">
                    <TabPane tab="All Shipments" key="1">
                    {data ? (
                        <Table
                            columns={columns}
                            dataSource={AllShipmentData || []}
                            rowKey="noResi"
                            pagination={{
                                current: currentPage,
                                pageSize: pageSize,
                                total: data.length,
                                showSizeChanger: true,
                                pageSizeOptions: ["5", "10", "20"],
                                onChange: (page, size) => {
                                    setCurrentPage(page);
                                    setPageSize(size);
                                }
                            }}
                            showHeader={false}
                            bordered={false}
                        />
                    ):(
                        <Spin spinning={loading} tip="Memuat data..." />
                    )}
                </TabPane>
                <TabPane tab="Active Shipments" key="2">
                    {data ? (
                        <Table
                            columns={columns}
                            dataSource={ActiveShipmentData || []}
                            rowKey="noResi"
                            pagination={{
                                current: currentPage,
                                pageSize: pageSize,
                                total: activeData.length,
                                showSizeChanger: true,
                                pageSizeOptions: ["5", "10", "20"],
                                onChange: (page, size) => {
                                    setCurrentPage(page);
                                    setPageSize(size);
                                }
                            }}
                            showHeader={false}
                            bordered={false}
                        />
                    ):(
                        <Spin spinning={loading} tip="Memuat data..." />
                    )}
                </TabPane>
                <TabPane tab="Watchlisted" key="3">
                    {/* {data ? (
                        <Table
                            columns={columns}
                            dataSource={paginatedData || []}
                            rowKey="id"
                            pagination={{
                                current: currentPage,
                                pageSize: pageSize,
                                total: data.length,
                                showSizeChanger: true,
                                pageSizeOptions: ["5", "10", "20"],
                                onChange: (page, size) => {
                                setCurrentPage(page);
                                setPageSize(size);
                                }
                            }}
                            showHeader={false}
                            bordered={false}
                        />
                        ):(
                            <Spin spinning={loading} tip="Memuat data..." />
                    )} */}
                </TabPane>
                </Tabs>
            </div>
            <Modal 
                title={viewMode ? "Detail Data Pengiriman" : editData ? "Edit Data Pengiriman" : "Tambah Data Pengiriman"}
                open={showModal}
                onCancel={handleCloseModal}
                width={isMobile ? "100%" : 900}
                centered={isMobile}
                bodyStyle={{
                    padding: isMobile ? 12 : 24,
                    background:
                        "linear-gradient(180deg,#ffffff 0%,#fafcff 100%)"
                }}
                tabPosition={isMobile ? "top" : "top"}
                footer={null}
            >
                <InputBarang 
                    modal={handleCloseModal}
                    editData={editData}
                    viewMode={viewMode}
                    hitApi={fetchData}
                    setLoadingSpin={setLoadingSpin}
                />
            </Modal>
            <Modal
                title="Update Status Pengiriman"
                open={statusModalOpen}
                onCancel={() => setStatusModalOpen(false)}
                onOk={async () => {
                    if (!selectedStatus) {
                    message.warning("Pilih status terlebih dahulu");
                    return;
                    }

                    try {
                    setStatusLoading(true);

                    await Promise.all(
                        selectedRecord.map(row => {
                        const payload = {
                            noResi: row.noResi,
                            kodeProses: STATUS_MAP[selectedStatus],
                            status: selectedStatus,
                            kodePengiriman: selectedKodePengiriman,
                            createdAt: result
                        };

                        return API.post("/api/tracking", payload);
                        })
                    );

                    message.success("Status berhasil diupdate");
                    setStatusModalOpen(false);
                    fetchData();
                    setSelectedRowKeys([]);
                    setSelectedRows([]);
                    } catch (error) {
                    message.error("Gagal update status");
                    console.error(error);
                    } finally {
                    setStatusLoading(false);
                    }
                }}
                confirmLoading={statusLoading}
            >
                <Row>
                    <Col span={24}>
                        <Select
                            style={{ width: "100%"}}
                            value={selectedStatus}
                            onChange={(value) => setSelectedStatus(value)}
                        >
                            {/* <Option value="">-- Pilih Status --</Option> */}
                            {STATUS_OPTION?.map((s) => (
                                <Option value={s.value}>
                                    {s.value}
                                </Option>
                            ))}
                        </Select>
                    </Col>
                </Row>
            </Modal>
            <PDFModal
                visible={pdfOpen}
                onClose={() => setPdfOpen(false)}
                pdf={<ResiPDF record={selectedRecord} />}
            />
        </div>
        <Drawer
            title={
                <div>
                    <div
                        style={{
                            fontSize: 20,
                            fontWeight: 700
                        }}
                    >
                        Tracking Shipment
                    </div>

                    <div
                        style={{
                            fontSize: 13,
                            color: "#888"
                        }}
                    >
                        {trackingRecord?.noResi}
                    </div>
                </div>
            }
            placement="right"
            width={window.innerWidth < 768 ? "100%" : 520}
            onClose={() => setTrackingOpen(false)}
            open={trackingOpen}
            bodyStyle={{
                background: "#f5f7fb",
                paddingBottom: 40
            }}
        >
            <Spin spinning={trackingLoading}>

                {/* HEADER CARD */}
                <Card
                    bordered={false}
                    style={{
                        borderRadius: 24,
                        marginBottom: 24,
                        boxShadow:
                            "0 8px 24px rgba(0,0,0,0.06)"
                    }}
                >
                    <Row gutter={[16, 16]}>
                        <Col span={12}>
                            <div className="label-card">
                                Pick-Up
                            </div>

                            <div className="value-card">
                                {trackingRecord?.namaPengirim}
                            </div>
                        </Col>

                        <Col span={12}>
                            <div className="label-card">
                                Delivery
                            </div>

                            <div className="value-card">
                                {trackingRecord?.namaPenerima}
                            </div>
                        </Col>

                        <Col span={12}>
                            <div className="label-card">
                                Origin
                            </div>

                            <div className="value-card">
                                {trackingRecord?.asalNegara || "Jakarta"}
                            </div>
                        </Col>

                        <Col span={12}>
                            <div className="label-card">
                                Destination
                            </div>

                            <div className="value-card">
                                {trackingRecord?.tujuanNegara || trackingRecord?.TujuanNegara || "-"}
                            </div>
                        </Col>
                    </Row>
                </Card>

                {/* TIMELINE */}
                <Timeline mode="left">

                    {trackingData.map((item, index) => {

                        const cfg =
                            trackingRecord?.kodePengiriman === "01"
                                ? statusConfigBarang[item.kodeProses]
                                : trackingRecord?.kodePengiriman === "02"
                                ? statusConfigUangOut[item.kodeProses]
                                : statusConfigUangIn[item.kodeProses];

                        return (
                            <Timeline.Item
                                key={index}
                                color={cfg?.color}
                                dot={cfg?.icon ? <div className={`timeline-dot-wrapper ${cfg.color}`}>{cfg.icon}</div> : null}
                            >
                                <Card
                                    size="small"
                                    bordered={false}
                                    style={{
                                        borderRadius: 18,
                                        background: "#fff",
                                        boxShadow:
                                            "0 4px 12px rgba(0,0,0,0.04)"
                                    }}
                                >
                                    <div
                                        style={{
                                            fontWeight: 700,
                                            fontSize: 16
                                        }}
                                    >
                                        {cfg?.label || item.status}
                                    </div>

                                    <div
                                        style={{
                                            color: "#666",
                                            marginTop: 4
                                        }}
                                    >
                                        {
                                            typeof cfg?.explain === "function"
                                                ? cfg.explain(trackingRecord)
                                                : cfg?.explain
                                        }
                                    </div>

                                    <div
                                        style={{
                                            marginTop: 12,
                                            display: "flex",
                                            alignItems: "center",
                                            gap: 8,
                                            color: "#888",
                                            fontSize: 12
                                        }}
                                    >
                                        <ClockCircleOutlined />

                                        {moment(item.createdAt).format(
                                            "DD MMM YYYY HH:mm"
                                        )}
                                    </div>
                                </Card>
                            </Timeline.Item>
                        );
                    })}
                </Timeline>
            </Spin>
        </Drawer>
        </>
    )
}
export default TableResult;